import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';
import './TestimonialsComponent.css';
import { useHistory } from "react-router";

import testimonials1 from '../../assets/img/avatar/avatar-client-1.png';
import testimonials2 from '../../assets/img/avatar/avatar-client-2.png';
import testimonials3 from '../../assets/img/avatar/avatar-client-3.png';
import testimonials4 from '../../assets/img/avatar/avatar-client-4.png';
import testimonials5 from '../../assets/img/avatar/avatar-client-5.png';

import testimonialsData from '../../assets/testimonialsHome.json';

const imageMap = {
  testimonials1,
  testimonials2,
  testimonials3,
  testimonials4,
  testimonials5
};

const TestimonialsComponent = () => {

    const history = useHistory();

    return (
        <div className="testimonial-banner">
        <div className="testimonial-container">
                <h2 className='section-title'>Testimonials</h2>
                <p className='section-info'>Why organizations rely on IAmInterviewed as their premier solution for technical interviews</p>

            {/* <div className="testimonial-wrapper">
                <Splide
                    options={{
                        rewind: true,
                        width: '100%',
                        gap: '1.5rem',
                        type: 'loop',
                        perPage: 1,
                        autoplay: true,
                        arrows: true,
                        pagination: false,
                    }}
                    aria-label="Testimonials">
                    <SplideSlide>
                        <div className="testimonial-single">
                            <div className='testimonial-user-pic' style={{ flex: '1'}}>
                                <img src={testimonials1} alt="CEO" />
                            </div>
                            <div style={{ flex: '2' }}>
                                <p>
                                    "IamInterviewed completely changed the pace at which we hire. What used to take weeks is now done in just a few days — without compromising quality. Their structured approach and lightning-fast turnaround have made hiring one of our strengths."
                                </p>
                                <h4>CEO</h4>
                                <h6>SaaS Startup</h6>
                            </div>
                        </div>
                    </SplideSlide>
                    <SplideSlide>
                        <div className="testimonial-single">
                            <div className='testimonial-user-pic' style={{ flex: '1'}}>
                                <img src={testimonials2} alt="Chief People Officer" />
                            </div>
                            <div style={{ flex: '2' }}>
                                <p>
                                    "The consistency they deliver at scale is unmatched. Even when we doubled our hiring load, their team maintained speed, accuracy, and professionalism. It’s rare to find a partner that can scale capacity without losing quality"
                                </p>
                                <h4>Chief People Officer</h4>
                                <h6>Technology Consulting Firm</h6>
                            </div>
                        </div>
                    </SplideSlide>
                    <SplideSlide>
                        <div className="testimonial-single">
                            <div className='testimonial-user-pic' style={{ flex: '1'}}>
                                <img src={testimonials3} alt="Head of Talent Acquisition" />
                            </div>
                            <div style={{ flex: '2' }}>
                                <p>
                                    "Their weekend support has been a real differentiator for us. We’ve been able to maintain hiring momentum even during tight delivery phases. IamInterviewed’s responsiveness and flexibility make them an indispensable partner.”
                                </p>
                                <h4>Head of Talent Acquisition</h4>
                                <h6>IT Services Company</h6>
                            </div>
                        </div>
                    </SplideSlide>
                </Splide>
            </div> */}
             <div className="testimonial-wrapper">
                <Splide
                    options={{
                    rewind: true,
                    width: '100%',
                    gap: '1.5rem',
                    type: 'loop',
                    perPage: 1,
                    autoplay: true,
                    arrows: true,
                    pagination: false,
                    }}
                    aria-label="Testimonials"
                >
                    {testimonialsData.map((item, index) => (
                    <SplideSlide key={index}>
                        <div className="testimonial-single">
                        <div className="testimonial-user-pic" style={{ flex: '1' }}>
                            <img src={imageMap[item.image as keyof typeof imageMap]} alt={item.alt} />
                        </div>
                        <div style={{ flex: '2' }}>
                            <p>"{item.text}"</p>
                            <h4>{item.name}</h4>
                            <h6>{item.company}</h6>
                        </div>
                        </div>
                    </SplideSlide>
                    ))}
                </Splide>
            </div>

            <p className='section-info read-more-testimonial'>
                Discover how leading organizations trust IAmInterviewed to streamline candidate assessments and strengthen their hiring pipelines. <br /> 
                <a onClick={(e) => { history.push("/testimonials") }}>Click here</a> to read more from our valued clients.
            </p>
        </div>
        </div>
    );
};
export default TestimonialsComponent;